import React, { useContext } from 'react'
import CertificatePicker from 'Components/reusable/InputFields/CertificatePicker'
import { ICertificate } from 'types/cvsInterfaces'
import { CertificateId } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextCertificateField = <T extends AnyObject>({
  field,
  dataField,
  usedCertificates,
  submitOnEnter,
  icon,
  placeholder,
  hideLabel,
  options,
  insetLabel,
  resetOnSelect,
  ...rest
}: {
  field: EditableFieldsOfType<T, CertificateId | null>
  dataField: EditableFieldsOfType<T, ICertificate | null>
  usedCertificates?: ICertificate[]
  submitOnEnter?: boolean
  icon?: React.ReactElement
  placeholder?: string
  hideLabel?: boolean
  options?: ICertificate[]
  insetLabel?: boolean
  resetOnSelect?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t, handleSubmit } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ICertificate | null) => {
    setFields({ [field]: newValue?.id ?? null, [dataField]: newValue })
  }

  const dataValue = flatData[dataField] as unknown as ICertificate

  return (
    <CertificatePicker
      onChange={handleChange}
      icon={icon}
      disabled={disabled[field]}
      value={dataValue ?? null}
      label={t(`${localeBase}.${field}`)}
      usedCertificates={usedCertificates}
      onKeyDown={e => submitOnEnter && handleSubmit(e)}
      placeholderText={placeholder}
      placeholderLabel={hideLabel ? placeholder : undefined}
      options={options}
      insetLabel={insetLabel}
      resetOnSelect={resetOnSelect}
      {...rest}
    />
  )
}

/**
 * Competence picker.
 */
